/**
 * API endpoint for user circles.
 */
export const CIRCLES_API = "/circles/user/";

